<template>
  <section id="hero">
    <v-carousel 
    cycle 
    vertical-delimiters
    hide-delimiter-background 
    :show-arrows='false'
    :hide-delimiters='true'
    :min-height="minHeight"
    :height="minHeight"
    class="carusel"
    >
      <v-carousel-item  v-for="(slide, i) in slides" :key="i">
            <!-- {{slide.nr}} -->
                <v-img
                  :min-height="minHeight"
                  :src="require(`@/assets/images/IMG_${slide.nr}.jpg`)"
                  class="white--text"
                  width="100%"
                  eager
                  gradient="to right, rgba(0,0,0, .6), rgba(0,0,0, .3),rgba(0,0,0, 0), rgba(0,0,0, 0)"
                  ></v-img>

      </v-carousel-item>
    </v-carousel>

      <v-container class="content fill-height fill-width">
        <v-responsive class="d-flex align-center" height="100%" max-width="700" width="100%">
          <base-heading :title="$t('sections.hero.header')" />
          <base-body class="description" v-html="$t('sections.hero.description')"></base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn to="/offer/overview">{{ $t('sections.hero.mainButton') }}</base-btn>
            <span class="or-sepearator font-weight-bold ml-6 mr-4 my-4">{{ $t('sections.hero.or') }}</span>
            <base-btn
              :ripple="false"
              class="pa-1 second-button"
              height="auto"
              text
              to="contact-us"
            >{{ $t('sections.hero.secondButton') }}</base-btn>
          </div>
        </v-responsive>
      </v-container>

  </section>
</template>

<script>

import Helper from '@/services/Helper'

export default {
  name: "SectionHero",
  provide: {
    theme: { isDark: true },
  },
  data() {

    const slides = [
        {
          nr: 7848
        },
        {
          nr: 7260
        },
        {
          nr: 7751
        },
        {
          nr: 7987
        },
      ];

    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: Helper.shuffleArray(slides)
    };
  },
  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "100vh";
      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
<style lang="scss">
#hero{
  position: relative;

  .description{
    font-weight: 400;
    color: white !important;

    > span{
      white-space: nowrap;
    }
  }

  .second-button{
    color: white !important;
  }

}
.content{
  width: 100%;
  position: absolute;
  top: 0;
  box-sizing: border-box;
  padding: 30px 60px 30px;
}
.or-sepearator{
  color: white;
}

.second-button, .or-sepearator{
  @media all and (max-width: 1000px) {
    display: none;
  }
}

.carusel{
  background: white;

  .v-image__image{
    background-attachment: fixed;
    filter: blur(0px);
  }
}
</style>
